<template>
  <v-navigation-drawer
    v-model="drawer"
    :absolute="isMobileBreakpoint"
    app
    width="270px"
    height="100%"
    clipped
    color="background"
    :temporary="isMobileBreakpoint"
    :permanent="!isMobileBreakpoint"
    :class="{
      fixNavDrawerHeight: isMobileBreakpoint,
      fixNavDrawerMobile: isMobileBreakpoint,
    }"
  >
    <the-toolbar :isNavDrawer="true" />
    <the-my-profile />
    <credits-payment-modal />
    <RecapModal
      :openRecapModal="openRecapModal"
      @closeRecapModal="openRecapModal = false"
    ></RecapModal>
    <plan-data-modal :data="$data" />
    <v-card flat class="d-flex flex-column" style="overflow: auto">
      <v-list
        class="mt-0 pt-0 px-4 invisible-scrollbar"
        nav
        style="width: 100%"
      >
        <v-list-item-group
          v-model="selectedItem"
          color="primary"
          mandatory
          style="overflow-y: auto; overflow-x: hidden"
        >
          <v-list-item
            v-for="(item, i) in navItems"
            :key="i"
            style="height: 48px"
            :style="$vuetify.theme.dark ? 'background: #171924 !important' : ''"
            exact
            router
            class="py-0 mb-0"
            :ripple="false"
            :class="{
              'v-list-item__rounded-outlined--dark': $vuetify.theme.dark,
              'textColor-list': !$vuetify.theme.dark,
              'textColor-list-dark': $vuetify.theme.dark,
              'panda-changelogfy-badge': item.route === 'news',
            }"
            @click="handleNavigationRoute(item.route)"
            @click.prevent="(e) => e.preventDefault()"
          >
            <v-list-item-icon
              class="mr-3"
              :style="
                $vuetify.theme.dark && selectedItem != i
                  ? 'background-color: #4d52588 !important'
                  : ''
              "
            >
              <!-- <v-icon v-text="item.icon"></v-icon> -->
              <v-card
                :class="{
                  imgCardDark: $vuetify.theme.dark,
                  imgCard: !$vuetify.theme.dark,
                  selectedImgCard: selectedItem === i,
                }"
                class="d-flex flex-row align-center justify-center elevation-0"
                style="width: 40px !important; height: 40px !important"
              >
                <img
                  :class="{
                    filterSvgColor: selectedItem === i,
                    svgColor: selectedItem != i,
                    filterSvgColorDark: $vuetify.theme.dark,
                  }"
                  :src="item.icon"
                  alt="Ícone"
                  style="overflow: visible"
                />
              </v-card>
            </v-list-item-icon>
            <v-list-item-content class="pt-2 pb-3">
              <v-row align="center" no-gutters>
                <v-list-item-title
                  v-html="item.text"
                  class="nav-drawer-item textType6--text"
                  :class="$vuetify.theme.dark ? '' : 'nav-drawer-item-light'"
                  style="flex: 1"
                ></v-list-item-title>
                <img
                  v-if="
                    (item.route === 'PandaAssist' ||
                      item.route === 'ShortlyPandaAssistAI') &&
                    !hasViewdPandaAssistAI
                  "
                  src="@/assets/icon-alert.svg"
                  style="height: 18px; padding-bottom: 2px"
                />
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
    <!-- <NavDrawerRecapBanner
      v-if="isRecapAvailable"
      @openRecapModal="openRecapModal = true"
    ></NavDrawerRecapBanner> -->
    <v-row
      no-gutters
      class="d-flex flex-column justify-space-between"
      v-if="canSeePlanInfo"
    >
      <v-row
        no-gutters
        class="d-flex flex-column justify-end"
        ref="infoInContainer"
        @mouseleave="handleOutInfoContainer"
        @mouseenter="handleInInfoContainer"
      >
        <template v-if="!error.loadPlanInfo">
          <v-card
            v-if="!planLoading"
            width="256px"
            flat
            :style="$vuetify.theme.dark ? 'border: 1px solid #d0d1d9;' : ''"
            class="mx-auto info-container planInfoContainer"
            style="cursor: pointer"
            @click="handleOpenPlanDataModal"
          >
            <template
              v-if="planInfo !== null && planInfo.subscription !== null"
            >
              <v-card-text
                class="mx-0 px-0 info-card-container"
                ref="infoCardContainer"
                style="padding: 0px !important"
              >
                <v-row no-gutters align="center" justify="center">
                  <v-col
                    cols="11"
                    class="d-flex justify-space-between align-center mb-3"
                  >
                    <v-row no-gutters>
                      <span class="planTexts">
                        <span class="normalPlanText"
                          >{{ $t('message.plan') }}:
                        </span>
                        <span
                          class="userPlanDrawerText"
                          @click="handlePlansPage"
                        >
                          <template
                            v-if="
                              planInfo.subscription &&
                              planInfo.subscription.name
                            "
                            ><span class="textType2--text">{{
                              planInfo.subscription.name
                            }}</span>
                          </template>
                          <template v-else>
                            {{ $t('message.pages.userPlan.noPlan') }}</template
                          >
                          <span class="textType2--text">
                            {{
                              planInfo.currency
                                ? `(${planInfo.currency.toUpperCase()})`
                                : ''
                            }}
                          </span>
                        </span>
                      </span>
                      <v-card
                        v-if="isUserTrialing"
                        class="elevation-0 ml-2 d-flex flex-row align-center justify-center px-4"
                        color="#BF3FEE"
                        style="border-radius: 16px"
                        width="40px"
                        dark
                      >
                        <span>Trial</span>
                      </v-card>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="11"
                    class="d-flex flex-row justify-space-between"
                  >
                    <span class="normalPlanText">{{
                      $t('message.storage')
                    }}</span>
                    <div>
                      <span class="limitInfoText">
                        <!-- {{ getTextStorage() }} -->
                        <b>{{ getTextStoragePercentage() }}</b>
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="11">
                    <progress-bar
                      :items="getStorageItems"
                      :totalLength="100"
                      :isTrafficModal="false"
                      :customHeight="8"
                      :dontShowEstimatedLine="true"
                      :showEstimated="false"
                    />
                  </v-col>
                  <v-col
                    cols="11"
                    class="d-flex flex-row justify-space-between mt-2"
                  >
                    <div>
                      <span
                        v-if="isUserTrialing"
                        class="normalPlanText pointer-click"
                        @click="handleOpenAddonsModal"
                        >{{ $t('message.navDrawer.traffic') }}&nbsp;<small
                          style="color: #ff5252; font-weight: 500"
                          >(Trial)</small
                        ></span
                      >
                      <span
                        v-else
                        class="normalPlanText"
                        @click="handleOpenAddonsModal"
                      >
                        {{ $t('message.mensalTraffic') }}
                      </span>
                    </div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="
                              trafficUsedPercent >= 100
                                ? 'var(--danger-color)'
                                : 'var(--alert-color)'
                            "
                            size="15px"
                            v-bind="attrs"
                            v-on="on"
                            v-show="trafficUsedPercent >= 90"
                            class="nav-drawer-action-icons"
                          >
                            mdi-alert
                          </v-icon>
                        </template>
                        <v-row no-gutters style="width: 240px">
                          <v-col cols="12" class="d-flex justify-space-between">
                            <span>{{
                              $t('message.progressBar.limitMessage')
                            }}</span>
                          </v-col>
                          <v-col cols="12" class="d-flex justify-space-between">
                            <span
                              >{{
                                $t(
                                  'message.navDrawer.userWarnings.trafficEndPlanWarn'
                                )
                              }}:
                              {{
                                formatDate(
                                  new Date(planInfo.limit.end_period),
                                  'dd/MM/yyyy'
                                )
                              }}</span
                            >
                          </v-col>
                        </v-row>
                      </v-tooltip>
                      <span class="limitInfoText" @click="openBandwidthChart">
                        <!-- {{ getTextTraffic() }} -->
                        <b>{{ getTextTrafficPercentage() }}</b>
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="11">
                    <progress-bar
                      :items="getTrafficBarInfo"
                      :totalLength="getTotalLength()"
                      :isTrafficModal="false"
                      :customHeight="8"
                      :customStripSize="8"
                      :dontShowEstimatedLine="true"
                      :showEstimated="true"
                      :splitLine="
                        planInfo.subscription.status === 'trialing' && {
                          color: 'red',
                          percentage: 40,
                          width: 2,
                        }
                      "
                    />
                  </v-col>
                  <v-col v-if="surpassLimitTraffic" cols="11" class="mt-3">
                    <v-card outlined elevation-0 class="pa-2 bandwidthErrCard">
                      <span class="bandwidthErrText1">
                        {{ $t('message.navDrawer.bandwithSurpass') }}
                        {{ updateLimitMaxUsage }}
                      </span>
                      <br />
                      <span class="bandwidthErrText2">
                        {{ $t('message.navDrawer.dontWorryBandwidthMsg') }}
                      </span>
                      <v-col cols="12" class="pa-0 mt-2">
                        <v-btn
                          small
                          block
                          color="primary"
                          @click="handleOpenPlanDataModal"
                          >{{ $t('message.navDrawer.planSettingsBtn') }}</v-btn
                        >
                      </v-col>
                    </v-card>
                  </v-col>
                  <v-row
                    no-gutters
                    class="hover-items"
                    ref="hoverItems"
                    justify="center"
                    align="center"
                  >
                    <!-- plays -->
                    <template v-if="getPlaysInfo && (isBeta || isDotCom)">
                      <v-col
                        cols="11"
                        class="d-flex flex-row justify-space-between"
                      >
                        <div>
                          <span class="planTexts">{{
                            $t('message.navDrawer.bottomActions.externalPlays')
                          }}</span>
                        </div>
                        <div>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                x-small
                                @click="openPlaysChart"
                                v-bind="attrs"
                                v-on="on"
                                style="margin-top: 1px"
                              >
                                <v-icon
                                  dense
                                  color="var(--v-primary-base)"
                                  size="16px"
                                >
                                  mdi-chart-box-outline
                                </v-icon>
                              </v-btn>
                            </template>
                            {{
                              $t(
                                'message.navDrawer.bottomActions.openPlaysModal'
                              )
                            }}
                          </v-tooltip>
                          <span class="usageText">
                            <b>{{ handleKamount(getPlaysInfo.play) }}</b
                            >/{{ handleKamount(getPlaysInfo.play_plan) }}</span
                          >
                        </div>
                      </v-col>
                      <v-col cols="11">
                        <progress-bar
                          :items="getPlaysProgressBarData"
                          :totalLength="getTotalPlays()"
                          :isTrafficModal="false"
                          :customHeight="8"
                          :customStripSize="8"
                          :dontShowEstimatedLine="true"
                          :showEstimated="false"
                        />
                      </v-col>

                      <v-col cols="11" class="d-flex justify-end">
                        <span class="planPercentage">
                          {{ getPlaysPercentage() }}%
                        </span>
                      </v-col>
                    </template>

                    <v-col
                      cols="11"
                      class="d-flex flex-row justify-space-between mt-3"
                      v-if="planInfo.limit.hasOwnProperty('traffic_drm')"
                    >
                      <button type="button" @click="handleOpenAddonsModal">
                        <span class="planTexts">Tráfego DRM</span>
                      </button>
                      <div>
                        <span
                          class="limitInfoText"
                          v-html="getTextDrmTraffic()"
                        >
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-row>
              </v-card-text>
            </template>
            <template v-else>
              <v-card-text>
                <v-col
                  cols="11"
                  class="d-flex flex-row justify-center align-center pb-0"
                >
                  <span class="caption">{{ $t('message.planNotFound') }}</span>
                </v-col>
                <v-col
                  cols="11"
                  class="d-flex flex-row justify-center align-center mt-4"
                >
                  <v-btn
                    class="primary white--text"
                    min-width="200px"
                    @click="handlePlansPage"
                  >
                    <span class="upgradeText"
                      >{{ $t('message.doUpgrade') }}
                      <v-icon right size="20">mdi-crown-outline</v-icon>
                    </span>
                  </v-btn>
                </v-col>
              </v-card-text>
            </template>
            <credits-drawer-info />
            <v-row
              v-if="planInfo.subscription.status === 'trialing'"
              no-gutters
              class="px-3 mt-4"
            >
              <v-btn
                block
                color="#BF3FEE"
                dark
                class="elevation-0"
                @click.stop="handleCompleteSubscription"
              >
                <span style="text-transform: none !important">
                  {{ $t('message.navDrawer.activePlan') }}
                </span>
              </v-btn>
            </v-row>
          </v-card>
          <v-card
            v-else
            class="d-flex flex-row justify-center align-center"
            height="170"
            width="256px"
            flat
            color="background"
          >
            <loading-logo />
          </v-card>
        </template>
        <template v-else>
          <v-card
            class="d-flex flex-column justify-center align-center"
            height="170"
            width="256px"
            flat
            color="background"
          >
            <span class="caption text-center">{{
              $t('message.failedToGetPlan')
            }}</span>
            <v-btn
              color="primary"
              small
              class="ma-2 ml-3 white--text"
              text
              @click="loadPlanData"
            >
              {{ $t('message.tryAgain') }}
              <v-icon right dark> mdi-cached </v-icon>
            </v-btn>
          </v-card>
        </template>
      </v-row>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import ProgressBar from '@/components/ProgressBar2.vue'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import prettyBytes from 'pretty-bytes'
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import externalSourceVideoMixin from '@/utils/externalSourceVideo.mixin.js'
import planApi from '../services/planApi'
import userApi from '../services/userApi'
import i18n from '@/translations/lang'
import { PANDA_AFFILIATES_LINK } from '@/config/envs.js'
import { format } from 'date-fns/esm'
import LoadingLogo from '@/components/LoadingLogo.vue'
import linkHelper from '@/utils/linkHelper.mixin.js'
import TheToolbar from '@/components/TheToolbar.vue'
import TheMyProfile from '@/components/TheMyProfile.vue'
import CreditsDrawerInfo from '@/views/Settings/Credits/CreditsDrawerInfo.vue'
import CreditsPaymentModal from '../views/Settings/Credits/CreditsPaymentModal.vue'
import PlanDataModal from '@/components/PlanDataModal.vue'
import videosApi from '@/services/videosApi'
//import NavDrawerRecapBanner from '@/components/Recap/NavDrawerRecapBanner.vue'
import RecapModal from '@/components/Recap/RecapModal.vue'
//import recapBannerMixin from '@/utils/recapBanner.mixin.js'

export default {
  name: 'TheNavigationDrawer',
  mixins: [
    calcMegabytesMixin,
    linkHelper,
    externalSourceVideoMixin,
    //recapBannerMixin,
  ],
  components: {
    'progress-bar': ProgressBar,
    LoadingLogo,
    TheToolbar,
    TheMyProfile,
    CreditsDrawerInfo,
    CreditsPaymentModal,
    PlanDataModal,
    //NavDrawerRecapBanner,
    RecapModal,
  },
  data() {
    return {
      isDotCom: false,
      infoCardContainerHeight: false,
      isRunningExpandAnimation: false,
      foldersOpen: false,
      selectedItem: 0,
      planLoading: false,
      plan: {
        name: 'Plano',
        storageLimit: 0,
        trafficLimit: 0,
      },
      items: [],
      filterText: '',
      error: {
        loadPlanInfo: false,
      },
      hasViewdPandaAssistAI: false,
      userRetrievedPlanInfo: {},
      userSubscription: {},
      userCards: [],
      forcePaymentLoading: false,
      forcePaymentError: false,
      forcePaymentMessage: '',
      isBeta: false,
      subscriptionId: '',
      stripeMenuUrl: '',
      stripeLoading: false,
      estimatedTraffic: null,
      trafficUsedPercent: 0,
      drawer: false,
      isLowerScreen: window.innerWidth < 768,
      changelogfyUnreadCount: 0,
      surpassedLimitTrafficValue: 0,
      openRecapModal: null,
    }
  },
  computed: {
    ...mapGetters('user', ['canSeePlanInfo']),
    ...mapState('user', {
      folders: 'mainFolders',
      planInfo: 'userPlanInfo',
      isMobileBreakpoint: 'isMobileBreakpoint',
      userFirstAccess: 'userFirstAccess',
      userPermissions: 'userPermissions',
      navItems: 'navItems',
      userAllInfo: 'userAllInfo',
      userPlanInfo: 'userPlanInfo',
      isRecapAvailable: 'isRecapAvailable',
    }),
    isUserTrialing() {
      return this.planInfo?.subscription?.status === 'trialing'
    },
    updateLimitMaxUsage() {
      let totalTraffic = this.userPlanInfo.limit?.traffic_plan
      let usedTraffic = this.planInfo.limit.traffic
      let diffValue = totalTraffic - usedTraffic ?? 0
      let prefSize = diffValue > 1000000 ? 'TB' : 'GB'
      if (diffValue < 0) {
        let calcVal = this.calcMegabytes(diffValue, 'MB', prefSize, true)
        return calcVal
      }
      return 0
    },
    surpassLimitTraffic() {
      let totalTraffic = this.userPlanInfo.limit?.traffic_plan
      let usedTraffic = this.planInfo.limit.traffic
      return totalTraffic <= usedTraffic
    },
    getTrialStyle() {
      return this.$i18next.resolvedLanguage === 'en'
        ? 'margin-left: 43px;'
        : 'margin-left: 12px;'
    },
    planInfoLimit() {
      if (this.planInfo && this.planInfo?.limit) {
        return this.planInfo.limit
      }
      return {}
    },
    getPlaysInfo() {
      if (
        !!this.planInfoLimit &&
        this.planInfoLimit.play &&
        this.planInfoLimit.play_plan
      ) {
        const { play, play_plan } = this.planInfoLimit
        return {
          play,
          play_plan,
        }
      }
      return false
    },
    isRootUser() {
      return this.$store.state.user?.userAllInfo?.is_root ?? false
    },
    trafficTextLength() {
      return this.getTextTraffic().length
    },
    trafficLink() {
      return this.getTrafficLink()
    },
    currentPlan() {
      return this.planInfo.subscription.name
    },
    trafficLimitReached() {
      return this.planInfo.limit.traffic > this.planInfo.limit.traffic_plan
    },
    hasAdditionalStorage() {
      if (this.planInfo.addons.storage) {
        return true
      }
      return false
    },
    hasAdditionalTraffic() {
      if (this.planInfo.addons.traffic) {
        return true
      }
      return false
    },
    tooltipTrafficWidth() {
      if (this.periodStart) {
        if (!this.hasAdditionalTraffic) return 'width: 240px;'
        return 'width: 230px;'
      }
      return 'width: 120px;'
    },
    periodStart() {
      if (this.planInfo.subscription.current_period_start) {
        return new Date(this.planInfo.subscription.current_period_start * 1000)
      }
      return false
    },
    periodEnd() {
      if (this.planInfo.subscription.current_period_end) {
        return new Date(this.planInfo.subscription.current_period_end * 1000)
      }
      return false
    },
    userPlanCycle() {
      const mask = 'HH:mm'

      if (this.planInfo?.limit) {
        const { start_period, end_period } = this.planInfo.limit
        return [
          format(new Date(start_period), mask),
          format(new Date(end_period), mask),
        ]
      }

      return false
    },
    trialDays() {
      const timeDifference =
        new Date(this.planInfo.subscription.trial_end * 1000).getTime() -
        new Date().getTime()
      const daysDifference = (timeDifference / (1000 * 3600 * 24)).toFixed(0)
      return daysDifference
    },
    userAlertError() {
      if (this.planInfo) {
        if (this.planInfo.subscription.active) {
          if (
            this.planInfo.subscription.type_payment &&
            this.planInfo.subscription.type_payment === 'boleto'
          ) {
            return i18n.t('message.navDrawer.userWarnings.paymentProblemTicket')
          } else {
            return i18n.t('message.navDrawer.userWarnings.paymentProblem')
          }
        }
      }
      return i18n.t('message.paymentError')
    },
    getTrafficBarInfo() {
      const usedTraffic = this.planInfo?.limit?.traffic
      const usedPercent = this.getUsedPercentage(usedTraffic)
      const estimatedTraffic = this.planInfo?.limit?.estimated_traffic
      const estimatedPercentage = this.getEstimatedPercentage(estimatedTraffic)
      return [
        {
          category: i18n.t('message.progressBar.usedWord'),
          length: this.calcMegabytes(usedTraffic),
          percentage: usedPercent,
        },
        {
          category: i18n.t('message.progressBar.estimatedWord'),
          length: this.calcMegabytes(estimatedTraffic),
          percentage: estimatedPercentage,
        },
      ]
    },
    getPlaysProgressBarData() {
      const percentage = this.getPlaysPercentage()
      const { play } = this.getPlaysInfo
      return [
        {
          category: i18n.t('message.progressBar.usedWord'),
          length: play,
          percentage,
        },
      ]
    },
    getStorageItems() {
      const usedStorage = this.planInfo.limit.storage
      const progressUsage = this.getProgressUsage(this.planInfo.limit)
      const usedPercent = progressUsage.storage
      return [
        {
          category: i18n.t('message.storage'),
          length: this.calcMegabytes(usedStorage),
          percentage: usedPercent,
        },
        {
          category: null,
          length: 0,
          percentage: 0,
        },
      ]
    },
  },
  async created() {
    this.isBeta = location.search.match('beta')
    this.isDotCom = !location.host.includes('.com.br')
    this.loadPlanData()
    localStorage.accessToken && (await this.getFolders())
  },
  async mounted() {
    this.$root.$on('emitCreateChangelogfy', () => {
      this.createChangelogfy()
    })
    this.$root.$on('refreshFolders', this.getFolders)
    this.$root.$on('refreshUserPlan', () => {
      this.loadPlanData()
    })
    this.$root.$on('toolbarEventOpenDrawer', () => {
      this.openDrawer()
    })
    this.$root.$on('changeNavItem', (itemIndex) => {
      this.selectedItem = itemIndex
    })
    this.$root.$on('fixUserLimit', async (isFromUppy) => {
      const userLimit = await this.fixUserLimit()
      this.UPDATE_USER_PLAN_INFO({
        addons: this.userSubscription.addons,
        subscription_id: this.subscriptionId,
        subscription: this.userRetrievedPlanInfo,
        limit: userLimit.data,
        type_payment: this.userSubscription.type_payment,
        user: {
          name: this.userSubscription.name,
          email: this.userSubscription.email,
        },
      })
      if (isFromUppy) {
        this.$root.$emit('loadedUserLimitToUppy')
      } else {
        this.$root.$emit('loadedUserLimit')
      }
    })
    this.$root.$on('changeLanguage', () => {
      this.$root.$emit('updateNavigationItems')
    })
    this.hasViewdPandaAssistAI = localStorage.getItem('hasViewdPandaAssistAI')
  },
  beforeDestroy() {
    this.$root.$off('refreshFolders')
    this.$root.$off('refreshUserPlan')
    this.$root.$off('fixUserLimit')
    this.$root.$off('changeLanguage')
  },
  methods: {
    openDrawer() {
      this.drawer = true
    },
    setNavigationRoute() {
      const routeName = this.$route.name
      this.selectedItem = this.navItems
        .map((item) => {
          return item.route
        })
        .indexOf(routeName)
    },
    async handleInInfoContainer() {
      if (!this.getPlaysInfo) return
      if (!this.isDotCom && !this.isBeta) return
      this.isRunningExpandAnimation = true
      const { infoCardContainer, hoverItems } = this.$refs
      const { clientHeight } = infoCardContainer
      if (!this.infoCardContainerHeight) {
        this.infoCardContainerHeight = clientHeight
      }
      infoCardContainer.style.maxHeight = `${this.infoCardContainerHeight}px`
      const _this = this
      setTimeout(() => {
        hoverItems.style.display = 'flex'
        hoverItems.style.opacity = '1'
        infoCardContainer.style.maxHeight = `${infoCardContainer.scrollHeight}px`
        _this.isRunningExpandAnimation = false
      }, 50)
    },
    handleOutInfoContainer() {
      if (this.isRunningExpandAnimation || !this.getPlaysInfo) return
      if (!this.isBeta && !this.isDotCom) return
      const { hoverItems, infoCardContainer } = this.$refs
      infoCardContainer.style.maxHeight = `${this.infoCardContainerHeight}px`
      hoverItems.style.opacity = '0'
      setTimeout(() => {
        hoverItems.style.display = 'none'
      }, 350)
    },
    handleStartCompletPlan() {
      this.$root.$emit('ModalResetBillingCycle')
    },
    handleCompleteSubscription() {
      this.$root.$emit('ModalResetBillingCycle')
    },
    getTotalLength() {
      let totalLength =
        this.planInfo.subscription.status === 'trialing'
          ? Number(this.planInfo.subscription.metadata.transfer) * 1024
          : this.planInfo?.limit?.traffic_plan
      return String(this.calcMegabytes(totalLength)).replace(',', '.')
    },
    getTotalPlays() {
      if (this.getPlaysInfo) {
        return this.getPlaysInfo.play_plan
      }
      return 0
    },
    handlePlansPage() {
      this.UPDATE_ONLY_CUSTOMIZING(false)
      this.$router.push({ name: 'Cart' })
    },
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_USER_PLAN_INFO',
      'UPDATE_ONLY_CUSTOMIZING',
    ]),
    ...mapActions('user', ['updateUserFolders']),
    handleNavigationRoute(page) {
      if (page === 'news') {
        this.openChangelogfy()
        return
      }
      if (page === 'Affiliates')
        return window.open(`${PANDA_AFFILIATES_LINK}`, '_blank')
      this.$route.name != page && this.$router.push({ name: `${page}` })
    },
    async openChangelogfy() {
      this.setNavigationRoute()
    },
    createChangelogfy() {
      if (window.changelogfy) {
        const client = document.getElementById('changelogfy-client')
        client?.remove()
        const script = document.getElementById('changelogfyScript')
        script?.remove()
        const config = document.getElementById('changelogfyConfig')
        config?.remove()
        window.changelogfy.destroy()
        window.changelogfy.logout()
        delete window.CLF_config
      }

      try {
        const plugin = document.createElement('script')
        plugin.id = 'changelogfyScript'
        plugin.setAttribute('src', 'https://widget.changelogfy.com/index.js')
        plugin.async = true
        document.head.appendChild(plugin)

        const script = document.createElement('script')
        script.id = 'changelogfyConfig'
        script.textContent = `let CLF_config = {
          app_id: "c2dba28d-a215-447f-ac88-12421156727b",
          selector: ".panda-changelogfy-badge",
          language: "${
            this.$i18next.resolvedLanguage === 'en' ? 'en' : 'pt-BR'
          }",
          data: {
            user_id: "${this.userAllInfo?.id}",
            user_email: "${this.userAllInfo?.email}",
            user_name: "${this.userAllInfo?.name}",
            custom_data: {
              organization_id: "${this.userAllInfo?.organization_id}",
              user_role: "${this.userAllInfo?.role_name}",
            }
          },
        };`
        document.head.appendChild(script)

        setTimeout(() => {
          if (window.changelogfy) {
            this.changelogfyUnreadCount = window.changelogfy.getUnreadCount()
          }
        }, 1500)
      } catch (e) {
        console.error(e)
      }
    },
    handleOpenPlanDataModal() {
      this.$root.$emit('openPlanDataModal')
    },
    async getFolders() {
      await this.updateUserFolders()
    },
    async handleAlertBtn() {
      try {
        let ret = await planApi.getReturnUrl(
          'https://dashboard.pandavideo.com.br',
          'pt-BR'
        )
        window.open(ret.data.url, 'blank')
      } catch (error) {
        console.log('error', error)
      }
    },
    handleUpgrade() {
      this.$root.$emit('Upgrade')
    },
    handleCart() {
      this.$router.push({ name: 'Cart' })
    },
    async loadPlanData() {
      this.planLoading = true
      this.error.loadPlanInfo = false
      try {
        const [ret, userLimit] = await Promise.all([
          planApi.getSubscription(),
          userApi.getUserLimit(),
        ])
        this.userRetrievedPlanInfo = ret.data.subscriptions
        this.subscriptionId = ret.data.subscription_id
        this.userSubscription = ret.data
        if (
          this.userSubscription.subscriptions &&
          this.userSubscription.subscriptions.active !== true
        ) {
          await planApi
            .getCards()
            .then(({ data }) => (this.userCards = data.cards))
        }
        this.UPDATE_USER_PLAN_INFO({
          addons: ret.data.addons ?? {},
          address: ret.data.address ?? null,
          taxId: ret.data.taxId ?? null,
          customer_created_at: ret.data.customer_created_at,
          currency: ret.data.currency,
          has_open_dispute: ret.data.has_open_dispute,
          subscription_id: ret.data.subscription_id ?? null,
          subscription: ret.data.subscriptions,
          type_payment: ret.data.type_payment,
          limit: userLimit.data,
          planId: ret.data.subscriptions?.id ?? null,
          schedule_update_due_date: ret.data.schedule_update_due_date ?? null,
          subscription_metadata: ret.data.subscription_metadata ?? {},
          customer_metadata: ret.data.customer_metadata ?? {},
          latest_invoice: ret.data.latest_invoice ?? null,
          latest_invoice_id: ret.data.latest_invoice_id ?? null,
          user: {
            name: this.userSubscription.name,
            email: this.userSubscription.email,
            phone: ret.data.phone,
          },
        })
        this.$root.$emit('updateNavigationItems')
        if (this.userFirstAccess) this.$root.$emit('openOnboardingModal')
        if (
          ret.data.subscription_id === undefined &&
          ret.data.subscriptions === null
        ) {
          this.$root.$emit('noSubscriptionModal')
          this.planLoading = false
          return
        }
        this.$root.$emit('showAccountWarning')
        this.updateCrisp({ subscription: ret.data })
        const isStaging = !!window.location.host.match(
          /stg.dashboard|localhost/
        )
        if (!isStaging) {
          this.tapFiliate({ subscription: ret.data })
        }
      } catch (e) {
        this.planLoading = false
        if (e.response?.status === 401) {
          this.$root.$emit('logout')
        }
        if (e.response?.data?.errCode === 'NotFound') {
          if (e.response?.data?.errMsg.match(/Library with user id/)) {
            if (localStorage.getItem('firstAccess'))
              this.$router.push({ name: 'Welcome' })
            else await this.verifyAccount()
          } else {
            await userApi.fixUserLimit()
            this.loadPlanData()
          }
          return
        }
        this.error.loadPlanInfo = true
      }
      this.planLoading = false
      this.$root.$emit('onFinishLoadPlanInfo')
    },
    async verifyAccount() {
      if (this.alreadyCreated) {
        this.$router.push({ name: 'Videos' })
      } else {
        const subscription = await this.checkStripe()
        if ((await this.checkLibrary()) && subscription) {
          this.alreadyCreated = true
          try {
            this.planAmount = subscription.data.subscriptions.unit_amount / 100
            this.currency = subscription.data.currency
          } catch {
            this.planAmount = 0
          }
          this.verifyAccount()
        } else {
          setTimeout(() => {
            this.verifyAccount()
          }, 2000)
        }
      }
    },
    async checkLibrary() {
      try {
        await videosApi.getVideos()
        return true
      } catch (e) {
        return false
      }
    },
    async checkStripe() {
      try {
        return await planApi.getSubscription()
      } catch (e) {
        return false
      }
    },
    async fixUserLimit() {
      try {
        const ret = await userApi.fixUserLimit()
        return ret
      } catch (e) {
        console.error(e)
      }
    },
    calcStoragePlanBytes(planStorage) {
      let bytes = 0
      planStorage > 1024
        ? (bytes = (planStorage / 1024) * 1e12)
        : (bytes = planStorage * 1e9)
      return `${prettyBytes(bytes, { maximumFractionDigits: 1 })}`
    },
    calcBytes(planStorage) {
      const bytes = planStorage * 1e9
      return `${prettyBytes(bytes, { maximumFractionDigits: 0 })}`
    },
    openBandwidthChart() {
      this.$root.$emit('changeNavItem', 5)
      this.$router.push({ name: 'AnalyticsV2Bandwidth' })
    },
    openPlaysChart() {
      this.$root.$emit('changeNavItem', 5)
      this.$router.push({ name: 'AnalyticsV2Play' })
    },
    getProgressUsage(usageLimit) {
      const percentStorage =
        (usageLimit.storage / usageLimit.storage_plan) * 100
      const percentTraffic =
        (usageLimit.traffic / usageLimit.traffic_plan) * 100
      return {
        storage: percentStorage,
        traffic: percentTraffic,
      }
    },
    getTextDrmTraffic() {
      let textDrmPlan = String(
        this.calcMegabytes(this.planInfo?.limit?.traffic_drm, 'MB', 'GB', true)
      ).replace(',', '.')
      return `<b>${textDrmPlan}</b>`
    },
    getTextStorage() {
      let textStorage = this.getTextUsedStorage()
      let textStoragePlan = this.getTextTotalStorage()

      return `<b>${textStorage}</b>/${textStoragePlan}`
    },
    getTextStoragePercentage() {
      let percent =
        Math.round(
          (this.planInfo?.limit?.storage / this.planInfo?.limit?.storage_plan) *
            100
        ) || 0
      if (percent > 100) {
        percent = 100
      }
      return `${String(percent.toFixed(0))}%`
    },
    getTextUsedStorage() {
      let textStorage = String(
        this.calcMegabytes(this.planInfo?.limit?.storage, 'MB', 'GB', true)
      ).replace(',', '.')
      return textStorage
    },
    getTextTotalStorage() {
      let textStoragePlan = String(
        this.calcMegabytes(this.planInfo?.limit?.storage_plan, 'MB', 'GB', true)
      ).replace(',', '.')
      return textStoragePlan
    },
    getPlanStorage() {
      let textStoragePlan = String(
        this.calcMegabytes(
          this.planInfo?.subscription?.metadata?.storage,
          'GB',
          'GB',
          true
        )
      ).replace(',', '.')
      return textStoragePlan
    },
    getAvailableStorage() {
      let sum =
        this.planInfo?.limit?.storage_plan - this.planInfo?.limit?.storage
      if (sum < 0) sum = 0

      let textStoragePlan = String(
        this.calcMegabytes(sum, 'MB', 'GB', true)
      ).replace(',', '.')

      return textStoragePlan
    },
    getAvailableTraffic() {
      let sum =
        this.planInfo?.limit?.traffic_plan - this.planInfo?.limit?.traffic
      if (sum < 0) sum = 0

      let text = String(this.calcMegabytes(sum, 'MB', 'GB', true)).replace(
        ',',
        '.'
      )

      return text
    },
    getSizeText() {
      let userStorage = parseInt(this.planInfo?.limit?.storage) * 1e6
      let allStorage =
        parseInt(this.userRetrievedPlanInfo.metadata.storage) * 1e6
      let addonStorage = allStorage - userStorage
      let textStorage = this.calcMegabytes(addonStorage)
      if (this.planInfo?.limit?.storage_plan > 999) {
        textStorage = `${(addonStorage / 1024).toFixed(1)} GB`
      }
      if (this.planInfo?.limit?.storage_plan > 999999) {
        textStorage = `${(addonStorage / (1024 * 1024)).toFixed(1)} TB`
      }
      let lastTextCaracter = textStorage
        .slice(textStorage.indexOf('.') + 1)
        .substring(0, 1)
      if (lastTextCaracter === '0') {
        textStorage = textStorage.replace('.0', '')
      }
      const textStoragePlan = this.calcMegabytes(addonStorage)
      return `${textStoragePlan}`
    },
    getTextTraffic() {
      const usedTraffic = this.getUsedTraffic()
      const totalTraffic = this.getTotalTraffic()

      this.estimatedTraffic = this.calcMegabytes(
        this.planInfo.limit.estimated_traffic,
        'MB',
        'GB',
        true
      )
      this.plan.trafficLimit = totalTraffic

      return `<b>${usedTraffic}</b>/${this.plan.trafficLimit}`.trim()
    },
    getTextTrafficPercentage() {
      this.trafficUsedPercent = this.getUsedPercentage(
        this.planInfo?.limit?.traffic
      )
      return `${String(this.trafficUsedPercent.toFixed(0))}%`
    },
    getPlaysPercentage() {
      if (this.getPlaysInfo) {
        const { play, play_plan } = this.getPlaysInfo
        return `${Number(((play / play_plan) * 100).toFixed(0))}`
      }
      return 0
    },
    getUsedTraffic() {
      const usedTraffic = String(
        this.calcMegabytes(this.planInfo?.limit?.traffic, 'MB', 'GB', true)
      ).replace(',', '.')
      return usedTraffic
    },
    getTotalTraffic() {
      let trafficVal = null
      this.planInfo.subscription.status === 'trialing'
        ? (trafficVal =
            Number(this.planInfo.subscription.metadata.transfer) * 1024)
        : (trafficVal = this.planInfo?.limit?.traffic_plan)
      const totalTraffic = String(
        this.calcMegabytes(trafficVal, 'MB', 'GB', true)
      ).replace(',', '.')
      return totalTraffic
    },
    updateCrisp({ subscription }) {
      try {
        if (!window.$crisp) return
        this.$crisp.push(['do', 'chat:show'])

        const emailOnSession = this.$crisp.get('user:email')
        if (
          emailOnSession &&
          emailOnSession !== this.$store.state.user.userInfo.email
        )
          this.$crisp.push(['do', 'session:reset', [false]])

        this.$crisp.push([
          'set',
          'user:email',
          [this.$store.state.user.userInfo.email],
        ])
        if (subscription?.name)
          this.$crisp.push(['set', 'user:nickname', [subscription.name]])
        if (subscription?.phone)
          this.$crisp.push(['set', 'user:phone', [subscription.phone]])
        if (subscription?.subscriptions) {
          this.$crisp.push([
            'set',
            'session:data',
            [
              [
                ['plan', `${subscription.subscriptions.name}`],
                ['status', `${subscription.subscriptions.status}`],
                ['last_access', new Date().toISOString()],
              ],
            ],
          ])
        }
      } catch (e) {
        console.error(e)
      }
    },
    tapFiliate({ subscription }) {
      try {
        if (
          subscription?.subscriptions &&
          subscription.subscriptions.status == 'trialing'
        ) {
          window.tap('trial', subscription.id)
        }
      } catch (e) {
        console.error(e)
      }
    },
    handleOpenAddonsModal() {
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$router.push({ name: 'Cart' })
    },
    async handleStripeSettings() {
      try {
        let ret = await planApi.getReturnUrl(
          'https://dashboard.pandavideo.com.br',
          'pt-BR'
        )
        this.stripeMenuUrl = ret.data.url
        this.goToStripe()
      } catch (error) {
        console.log('error', error)
      }
      this.stripeLoading = false
    },
    goToStripe() {
      if (this.stripeMenuUrl === '') {
        this.stripeLoading = true
        setTimeout(() => {
          this.goToStripe()
        }, 1000)
      } else {
        window.open(this.stripeMenuUrl, '_self')
        this.stripeLoading = false
      }
    },
    getUsedPercentage(usedLength) {
      let totalTraffic =
        this.planInfo.subscription.status === 'trialing'
          ? Number(this.planInfo.subscription.metadata.transfer) * 1024
          : this.planInfo.limit
          ? this.planInfo.limit.traffic_plan
          : 0
      return (usedLength / totalTraffic) * 100
    },
    getEstimatedPercentage(estimatedTraffic) {
      const estimatedNumber = (
        (estimatedTraffic /
          (this.planInfo.limit ? this.planInfo.limit.traffic_plan : 0)) *
        100
      ).toFixed(2)
      const isFloat =
        String(estimatedNumber).split('.')[1] === '00' ? false : true

      return isFloat
        ? (
            (estimatedTraffic /
              (this.planInfo.limit ? this.planInfo.limit.traffic_plan : 0)) *
            100
          ).toFixed(2)
        : Number.parseInt(
            (estimatedTraffic /
              (this.planInfo.limit ? this.planInfo.limit.traffic_plan : 0)) *
              100
          )
    },
    formatDate(date, pattern) {
      return format(date, pattern)
    },
    async tryPaymentAgain() {
      try {
        if (this.userSubscription.latest_invoice === 'open') {
          this.forcePaymentLoading = true
          this.forcePaymentError = false

          let ret = await planApi.forcePayment(
            this.userSubscription.latest_invoice_id
          )
          this.forcePaymentLoading = false

          this.loadPlanData()
          this.handleSnackbar(
            this.$t('message.navDrawer.forcePayment.successMessage')
          )

          return ret
        }
      } catch (error) {
        this.forcePaymentMessage = error.response.data.errMsg.error
        this.forcePaymentLoading = false
        this.forcePaymentError = true
        console.log('error', error)
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.navDrawer.successMessage')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
  },
  watch: {
    navItems(navItems) {
      if (navItems.length > 0) {
        this.setNavigationRoute()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list-item:hover .v-card {
  background-color: inherit !important;
}

.v-list-item--active .v-card {
  background-color: #4d5258 !important;
}

.filterSvgColorDark {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%)
    contrast(100%);
}

.svgColor {
  filter: none;
}
.planInfoContainer {
  border-radius: 8px;
  background: #f9f9fb;
  margin: 20px;
  padding: 12px;
}
.v-list-item__icon {
  margin: 0px 8px 0px 0px !important;
}
.v-list-item-group .v-list-item--active {
  font-weight: 600px !important;
  color: #0f22a1;
  .nav-drawer-item-light {
    color: #0f22a1 !important;
  }
  .imgCard {
    background: #ebeeff !important;
  }
  .imgCardDark {
    background: #0f22a1 !important;
  }
  .selectedImgCard {
    border-radius: 32px;
  }
}

.lock-icon {
  position: relative;
}

.invisible-scrollbar {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.v-list--nav .v-list-item,
.v-list--nav .v-list-item:before {
  border-radius: 4px;
  background: white;
}

.invisible-scrollbar {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.v-list--nav .v-list-item,
.v-list--nav .v-list-item:before {
  border-radius: 4px;
  background: white;
}

.textColor-list:hover {
  color: #4d5258 !important;

  .svgColor {
    filter: invert(9%) sepia(94%) saturate(5598%) hue-rotate(235deg)
      brightness(99%) contrast(103%);
  }

  .filterSvgColor {
    filter: invert(9%) sepia(94%) saturate(5598%) hue-rotate(235deg)
      brightness(99%) contrast(103%);
  }
}

.v-list-item--active.textColor-list:hover {
  color: #0f22a1 !important;
  background: inherit !important;

  .svgColor,
  .filterSvgColor {
    filter: invert(9%) sepia(94%) saturate(5598%) hue-rotate(235deg)
      brightness(99%) contrast(103%);
  }
}

.textColor-list:active {
  color: #0f22a1 !important;
  .svgColor {
    filter: invert(9%) sepia(94%) saturate(5598%) hue-rotate(235deg)
      brightness(99%) contrast(103%);
  }
}

.textColor-list-dark:hover {
  color: #4d5258 !important;

  .svgColor {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg)
      brightness(100%) contrast(100%);
  }

  .filterSvgColor {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg)
      brightness(100%) contrast(100%);
  }
}

.v-list-item--active.textColor-list-dark:hover {
  color: white !important;
  background: inherit !important;

  .svgColor,
  .filterSvgColor {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg)
      brightness(100%) contrast(100%);
  }
}

.textColor-list-dark:active {
  color: white !important;
  .svgColor {
    filter: invert(9%) sepia(94%) saturate(5598%) hue-rotate(235deg)
      brightness(99%) contrast(103%);
  }
}

::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}
::v-deep .v-navigation-drawer__border {
  display: none;
}
</style>

<style>
.noIbar {
  cursor: default;
}

.pointer-click {
  cursor: pointer;
}

.no-bold {
  font-weight: 500 !important;
}

.usageText {
  font-weight: 400;
  font-size: 10px;
  margin-top: 1.88px;
  color: var(--v-blueMarine-base);
}

.upgradeText {
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}

.alertText {
  font-size: 11px;
  line-height: 1.3;
}

.errorText {
  font-weight: 500;
  font-size: 11px;
  line-height: 2.3;
}

.nav-drawer-item {
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.planTexts {
  font-style: normal;
  font-size: 12px;
  font-weight: 500;
  color: var(--v-blueMarine-base);
}

.upgradeTextCta {
  font-weight: 400;
  color: var(--v-primary-base);
}

.drmText {
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  color: #878787;
}

.plan-text {
  font-weight: 500;
  font-size: 12px;
}

.plus-button {
  margin-top: 1px !important;
  margin-right: 1px;
}

.plus-button i {
  font-size: 14px !important;
}

.nav-drawer-action-icons {
  margin-top: 2px;
}

#crisp-chatbox span .cc-1vyl {
  display: none !important;
}

.planName {
  font-size: 0.875rem;
  color: var(--v-blueMarine-darken2);
}

.planNameTitle {
  text-transform: capitalize;
  font-weight: 400;
  color: var(--v-blueMarine-base);
}

.planPercentage {
  font-size: 12px;
  color: var(--v-blueMarine-base);
}

.addText {
  margin-left: 8px;
  color: var(--v-primary-base) !important;
}

.plus-button-special {
  display: none;
}

.custom-tooltip {
  opacity: 0.9 !important;
  background-color: #616161;
}

@media only screen and (min-width: 1440px) {
  .v-list-item.v-list-item--link.theme--light {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
span button.v-btn span.v-btn__loader {
  height: 15px;
  width: 15px;
  margin-top: -5px;
}

.fixNavDrawerMobile {
  height: 100dvh !important;
}

.fixNavDrawerHeight .v-navigation-drawer__content {
  height: 100% !important;
}

html body .v-list-item__rounded-outlined .v-list-item__icon {
  margin: 0px;
  margin-bottom: 2px;
  align-self: auto;
}

.v-list-item__rounded-outlined.v-item--active {
  height: 44px;
  border: 1px solid #a0acff;
}

.v-list-item__rounded-outlined:not(.v-item--active) .v-list-item__content {
  color: var(--v-blueMarine-base);
}

.v-list-item__rounded-outlined:not(.v-item--active) .v-icon {
  color: var(--v-blueMarine-lighten1);
}

.v-list-item__rounded-outlined {
  border: 1px solid transparent;
}

.v-list-item__rounded-outlined--dark.v-item--active {
  border: 1px solid transparent;
  background: #ebedff;
  color: #171924;
}

.v-list-item__rounded-outlined--dark.v-item--active::before {
  opacity: 0 !important;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0;
}

.v-list-item__rounded-outlined--dark:not(.v-item--active)
  .v-list-item__content {
  color: var(--v-blueMarine-base);
}

.v-list-item__rounded-outlined--dark.v-item--active .v-list-item__content {
  color: #171924;
}

.v-list-item__rounded-outlined--dark:not(.v-item--active) .v-icon {
  color: #585d83;
}

.v-list-item__rounded-outlined--dark.v-item--active .v-icon {
  color: #373b54;
}

.v-list-item__rounded-outlined--dark {
  border: 1px solid transparent;
}

.hover-items {
  display: none;
  transition: opacity 0.3s;
  opacity: 0;
}

@keyframes showInfo {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes hideInfo {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes showInfoInContainer {
  from {
    transform: translate(0px, 0px);
  }
  to {
    transform: translate(0px, -50px);
  }
}

@keyframes hideInfoInContainer {
  from {
    transform: translate(0px, -50px);
  }
  to {
    transform: translate(0px, 0px);
  }
}

@keyframes floating {
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(0px, -5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}

.info-container {
  position: relative;
}

.info-card-container {
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
.changelogfy-launcher {
  visibility: hidden !important;
}
.changelogfy-badge-container {
  right: 91% !important;
  bottom: 20% !important;
}

.changelogfy-badge-container .changelogfy-badge:after,
.changelogfy-badge-container .changelogfy-badge:before {
  width: 17px !important;
  height: 17px !important;
}

.changelogfy-badge-container .changelogfy-badge {
  height: 15px !important;
  width: 15px !important;
}
.filterSvgColor {
  filter: invert(9%) sepia(94%) saturate(5598%) hue-rotate(235deg)
    brightness(99%) contrast(103%);
}
.normalPlanText {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}
.userPlanDrawerText {
  color: #3f404c;
  font-size: 12px;
  font-weight: 500;
  line-height: 150%; /* 18px */
}
.limitInfoText {
  color: #3f404c;
  font-size: 12px;
  font-weight: 500;
}
.bandwidthErrText1 {
  font-size: 12px;
  font-weight: 500;
}
.bandwidthErrText2 {
  font-size: 12px;
  font-weight: 400;
}
.bandwidthErrCard {
  border-radius: 4px;
  border: 1px solid #d0d1d9;
  background: #fff;
}
</style>
